import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import encodeListFilterValues, { readListFilterValues } from "~/helpers/listFilterValues";

const SITE_LIST_TARGET_KIND = "siteList";

const FULFILL_LOCATIONS_PATH = "/fulfill/locations";

const FULFILL_LOCATIONS_DOCK_PAGE_ID = "locations";

const buildSiteListTarget = (listId: string, siteLocationIds: readonly string[]): ContinuationTarget => ({
	listFilters: { siteLocationIds: encodeListFilterValues(siteLocationIds) },
	targetId: listId,
	targetKind: SITE_LIST_TARGET_KIND
});

const readSiteListScope = (listFilters: Record<string, string> | undefined): null | string[] =>
	readListFilterValues(listFilters?.siteLocationIds);

const missingSiteIds = (siteLocationIds: readonly string[], sites: readonly { siteLocationId: string }[]): string[] =>
	siteLocationIds.filter((id) => !sites.some((site) => site.siteLocationId === id));

const siteListReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: () => FULFILL_LOCATIONS_PATH,
	matchesRoute: () => null
};

const siteListScope = {
	adapter: siteListReceiverIdentityAdapter,
	buildSiteListTarget,
	FULFILL_LOCATIONS_DOCK_PAGE_ID,
	missingSiteIds,
	readSiteListScope,
	SITE_LIST_TARGET_KIND
} as const;

export default siteListScope;
